import { combineReducers } from 'redux';

import screensReducer from '../screens/screensReducer';
import entitiesReducer from './entities';
import applicationReducer from './application';
import userReducer from './user';

// Common configuration between Web and Native
const reducers = {
  screens: screensReducer,
  entities: entitiesReducer,
  application: applicationReducer,
  user: userReducer,
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
